export default {"src":"https://fishbrain.com/_next/static/media/utah.ba8de43f.svg","height":128,"width":128,"blurWidth":0,"blurHeight":0};